import { render, staticRenderFns } from "./index.vue?vue&type=template&id=44ac6447"
import script from "./role.js?vue&type=script&lang=js&external"
export * from "./role.js?vue&type=script&lang=js&external"
import style0 from "./role.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports